import React from 'react';
import LineInterface from 'app/interfaces/LineInterface';
import GamerPhoto from 'app/components/bet_form/GamerPhoto';
import {lineGamer} from 'app/lines/lineGamer';
import {showBetForm} from 'app/components/table';
import {GAMER_1, GAMER_2} from 'app/utils/Consts';
import {fixed3} from 'app/utils/fixed';

interface Props {
    bet: LineInterface
    tournament_name: string
}

const SlidingStreamersCoefLine = ({bet, tournament_name}: Props): React.ReactNode => {
    const openBetForm = (on: number): void => showBetForm({hash_id: bet.hash_id}, on, {openBetSlip: true, showLoading: false});
    const openBetForm1 = (): void => openBetForm(GAMER_1);
    const openBetForm2 = (): void => openBetForm(GAMER_2);

    return <div className="sliding-streamers-coef__line">
        <div className="sliding-streamers-coef__team">
            <GamerPhoto line_gamer={lineGamer(bet, GAMER_1)}/>
            <span className="sliding-streamers-coef__coef" onClick={openBetForm1}>
                {fixed3(bet?.coef_1)}
            </span>
        </div>
        <div className="sliding-streamers-coef__streamer">
            <span className="sliding-streamers-coef__streamer-name">
                {tournament_name}
            </span>
        </div>
        <div className="sliding-streamers-coef__team">
            <GamerPhoto line_gamer={lineGamer(bet, GAMER_2)}/>
            <span className="sliding-streamers-coef__coef" onClick={openBetForm2}>
                {fixed3(bet?.coef_2)}
            </span>
        </div>
    </div>;
};

export default SlidingStreamersCoefLine;
